import { render, staticRenderFns } from "./createCardStep.vue?vue&type=template&id=d600a6c4&scoped=true&"
import script from "./createCardStep.vue?vue&type=script&lang=js&"
export * from "./createCardStep.vue?vue&type=script&lang=js&"
import style0 from "./createCardStep.vue?vue&type=style&index=0&id=d600a6c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d600a6c4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SimpleCard: require('/opt/build/repo/components/widgets/Simple-card.vue').default,TableCard: require('/opt/build/repo/components/widgets/Table-card.vue').default,ManageTags: require('/opt/build/repo/components/DashboardModals/manageTags.vue').default})
